export default __webpack_public_path__ + "static/media/swf-footer-desktop.7afa97f3.jpg";